import Api from '../http.service';

/**
 *
 * @param {object} payload
 * @param {string} payload.pageNumber
 * @param {string} payload.itemPerPage
 */

export const getAll = (payload) =>
  Api.GET({
    url: `bank_account/me/${payload.pageNumber - 1}/${payload.itemPerPage}`,
  });
/**
 *
 * @param {object} payload
 * @param {object} payload.data
 * @param {string} payload.data.id
 */
export const remove = (payload) =>
  Api.DELETE({ url: `bank_account`, data: payload.data });

/**
 *
 * @param {object} payload
 * @param {object} payload.data
 * @param {string} payload.data.cardNo
 * @param {string} payload.data.bankName
 * @param {string} payload.data.bankAccountTypeId
 * @param {string} payload.data.country
 * @param {string} payload.data.branchName
 * @param {string} payload.data.accountNo
 * @param {string} payload.data.shebaNo
 * @param {string} payload.data.isDefault
 */
export const insert = (payload) =>
  Api.POST({ url: 'bank_account/me', data: payload.data });

/**
 *
 * @param {object} payload
 * @param {object} payload.data
 * @param {string} payload.data.id
 * @param {string} payload.data.cardNo
 * @param {string} payload.data.bankName
 * @param {string} payload.data.bankAccountTypeId
 * @param {string} payload.data.country
 * @param {string} payload.data.branchName
 * @param {string} payload.data.accountNo
 * @param {string} payload.data.shebaNo
 * @param {string} payload.data.isDefault
 */
export const update = (payload) =>
  Api.POST({ url: 'bank_account/me', data: payload.data });
